<!-- Hero Section -->
<section class="hero-section">
    <div class="page-title-area">
        <img src="assets/images/macbook-air/hero_large.png" alt="Page Background" class="page-bg" style="width: 50%; height: 50%; object-fit: contain; position: absolute; left: 40%; top: 20%; transform: translateX(20%);">
        <div class="container">
            <div class="hero-content">
                <img src="assets/images/macbook-air/logo.png" alt="MacBook Air" class="hero-logo">
                    <h2 style="background: rgba(0, 125, 250, 0.6);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    font-size: 52px;
                    margin-top: 20px;
                    line-height: 1.1;">Speed of lightness.</h2>
                    <p>MacBook Air with the M4 chip lets you blaze through everything you're into while delivering up to 18 hours of battery life. And you have four gorgeous colors to choose from, including a stunning Sky Blue. With the perfectly portable MacBook Air, you'll be ready to take on just about anything, anywhere.</p>
                    <div class="hero-buttons">
                        <!-- <a routerLink="/contact" class="primary-btn">Buy Now</a> -->
                        <!-- <a routerLink="/contact" class="secondary-btn">Contact Sales</a> -->
                    </div>
            </div>
        </div>
    </div>
    <!-- <div class="page">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-content">
                    <h1>MacBook Air</h1>
                    <h2>Speed of lightness.</h2>
                    <p>MacBook Air with the M4 chip lets you blaze through everything you're into while delivering up to 18 hours of battery life. And you have four gorgeous colors to choose from, including a stunning Sky Blue. With the perfectly portable MacBook Air, you'll be ready to take on just about anything, anywhere.</p>
                    <div class="hero-buttons">
                        <a routerLink="/contact" class="primary-btn">Buy Now</a>
                        <a routerLink="/contact" class="secondary-btn">Contact Sales</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="hero-image">
                    <img src="assets/images/products/macbook-air.jpg" alt="MacBook Air M4">
                </div>
            </div>
        </div>
    </div> -->
</section>


<!-- Features Section -->
<section class="features-section">
    <div class="container">
        <div class="row">
            <!-- Size Options -->
            <div class="col-lg-6">
                <div class="feature-card">
                    <h3>Two perfect sizes.</h3>
                    <div class="size-options">
                        <div class="size-option">
                            <img src="assets/images/macbook-air/sizes.png" alt="MacBook Air Sizes">
                            <div class="size-labels">
                                <div class="size-label">
                                    <h4>15"</h4>
                                    <p>display</p>
                                </div>
                                <div class="size-label">
                                    <h4>13"</h4>
                                    <p>display</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Color Options -->
            <div class="col-lg-6">
                <div class="feature-card">
                    <h3>Four beautiful colors. Now with Sky Blue.</h3>
                    <div class="color-options">
                        <div class="color-image-container">
                            <img src="assets/images/macbook-air/color.png" alt="MacBook Air Colors">
                            <div class="color-labels">
                                <span class="color-label sky-blue">Sky Blue</span>
                                <span class="color-label silver">Silver</span>
                                <span class="color-label starlight">Starlight</span>
                                <span class="color-label midnight">Midnight</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Performance Section -->
<section class="performance-section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="performance-content">
                    <h3>The chip that zips.</h3>
                    <img src="assets/images/macbook-air/m4.png" alt="MacBook Air M4 Chip">
                    <div class="performance-stats">
                        <div class="stat">
                            <h4>Up to 23x</h4>
                            <p>faster than fastest Intel‑based MacBook Air</p>
                        </div>
                        <div class="stat">
                            <h4>Up to 2x</h4>
                            <p>faster than MacBook Air (M1)</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="performance-image">
                    <img src="assets/images/macbook-air/chip.png" alt="MacBook Air M4 Chip">
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Battery Life Section -->
<section class="battery-section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="battery-image">
                    <img src="assets/images/macbook-air/battery.jpg" alt="MacBook Air Battery Life">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="battery-content">
                    <h3>All‑day battery life.</h3>
                    <div class="battery-stats">
                        <h4>Up to 18 hrs</h4>
                        <img src="assets/images/macbook-air/battery_large.png" alt="MacBook Air Battery Life" style="width: 200px; height: 100px; margin-bottom: 10px;">
                        <p>of battery life for all-day productivity</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Display Section -->
<section class="display-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="display-content">
                    <h3 style="text-align: center;">Liquid Retina display. Love at every sight.</h3>
                    <div class="display-image">
                        <img src="assets/images/macbook-air/liquid-retina.jpg" alt="MacBook Air Display">
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="display-content">
                    <h3 style="text-align: center;">Look and sound your best</h3>
                    <div class="feature-card">
                        <div class="feature-content">
                            <div class="feature-icon">
                                <img src="assets/images/macbook-air/icon_person_fill.png" alt="Camera">
                            </div>
                            <p>12MP Center Stage camera with Desk View</p>
                        </div>
                        <div class="feature-content">
                            <div class="feature-icon">
                                <img src="assets/images/macbook-air/icon_waveform.png" alt="Audio">
                            </div>
                            <p>Three‑mic array</p>
                        </div>
                        <div class="feature-content">
                            <div class="feature-icon">
                                <img src="assets/images/macbook-air/icon_person_spatialaudio.png" alt="Spatial Audio">
                            </div>
                            <p>Immersive sound system with Spatial Audio</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="display-content" style="margin: 30px;">
                    <h2 style="text-align: center; margin-top: 30px; margin-bottom: 30px;">Support for up to two external displays</h2>
                    <div class="display-image">
                        <img src="assets/images/macbook-air/external-display.jpg" alt="MacBook Air Display" style="width: 60%; height: 60%; margin: 0 auto;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Features Grid -->
<section class="features-grid">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="feature-section">
                    <h2>Well connected.</h2>
                    <div class="connections-container">
                        <div class="connections-image">
                            <img src="assets/images/macbook-air/connections.png" alt="MacBook Air Ports" style="width: 100%; height: auto;">
                            <div class="port-label thunderbolt">Two Thunderbolt 4 ports</div>
                            <div class="port-label magsafe">MagSafe</div>
                            <div class="port-label headphone">Headphone jack</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="feature-section">
                    <h2>Backlit Magic Keyboard with Touch ID.</h2>
                    <div class="keyboard-section">
                        <div class="keyboard-image">
                            <img src="assets/images/macbook-air/touch-id.jpg" alt="MacBook Air Keyboard" style="width: 85%; height: auto;">
                        </div>
                        <div class="touch-id-icon">
                            <img src="assets/images/macbook-air/icon_touchid_elevated.png" alt="Touch ID" style="width: 50px; height: 50px;" class="touch-id-mobile">
                            <p>Touch ID</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- AI Section -->
<section class="ai-section">
    <div class="container">
        <div class="row align-items-center ai-content-container">
            <div class="col-lg-6">
                <div class="ai-content">
                    <h2>
                        <span class="gradient-text">Built for</span><br>
                        <span class="gradient-text">Apple Intelligence.</span>
                    </h2>
                    <h3>Personal, private, powerful.</h3>
                    <p>Available now in English</p>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="ai-image">
                    <img src="assets/images/macbook-air/apple-intelligence.jpg" alt="MacBook Air Apple Intelligence" style="width: 100%; height: auto;">
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Upgrade Section -->
<!-- <section class="upgrade-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="upgrade-content">
                    <h3>There's never been a better time to upgrade.</h3>
                    <div class="upgrade-comparison">
                        <div class="comparison-item">
                            <h4>MacBook Air (Intel-based)</h4>
                            <ul>
                                <li>Up to 23x faster performance</li>
                                <li>Built for Apple Intelligence</li>
                                <li>Up to 6 more hours battery life</li>
                                <li>Neural Engine for AI features</li>
                            </ul>
                        </div>
                        <div class="comparison-item">
                            <h4>MacBook Air (M1)</h4>
                            <ul>
                                <li>Up to 2x faster performance</li>
                                <li>Enhanced battery life</li>
                                <li>Improved graphics performance</li>
                                <li>Better thermal efficiency</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- Accessories Section -->
<!-- <section class="accessories-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="accessories-content">
                    <h3>Accessories</h3>
                    <p>Explore Mac accessories.</p>
                    <div class="accessories-grid">
                        <div class="accessory-item">
                            <img src="assets/images/products/airpods-max.jpg" alt="AirPods Max">
                            <h4>AirPods Max</h4>
                        </div>
                        <div class="accessory-item">
                            <img src="assets/images/products/magic-keyboard.jpg" alt="Magic Keyboard">
                            <h4>Magic Keyboard</h4>
                        </div>
                        <div class="accessory-item">
                            <img src="assets/images/products/magic-mouse.jpg" alt="Magic Mouse">
                            <h4>Magic Mouse</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- AppleCare Section -->
<!-- <section class="applecare-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="applecare-content">
                    <h3>AppleCare+</h3>
                    <p>Expert support, enhanced coverage.</p>
                    <div class="applecare-features">
                        <div class="feature">
                            <h4>Apple‑certified service</h4>
                            <p>Get expert repairs and support from Apple-certified technicians.</p>
                        </div>
                        <div class="feature">
                            <h4>Priority access to Apple experts</h4>
                            <p>Get help when you need it with priority access to Apple support.</p>
                        </div>
                        <div class="feature">
                            <h4>Accidental damage coverage</h4>
                            <p>Protect your MacBook Air from accidental damage.</p>
                        </div>
                    </div>
                    <a routerLink="/applecare" class="learn-more-btn">Learn more about AppleCare+ for Mac</a>
                </div>
            </div>
        </div>
    </div>
</section> -->


